export class StatesDto {
    stateId?: number;
    stateName: string;

    constructor(stateId:number,stateName:string){
        this.stateId = stateId;
        this.stateName = stateName;
        
    }
}